import styled from 'styled-components';

import moreIcon from 'assets/more.svg';

export const MoreIcon = styled.img.attrs({
  src: moreIcon,
})``;
